export default "/images/55b5680fe10d9ec9a841f5bef3986c6f.avif";